module.exports = __webpack_public_path__ + "static/media/mito01.d3e09b53.jpg";